export class LectureDto {
    public seq: number = 0;
    public title: string = "";
    public content: string = "";
    public expiredDate: string = "";
    public price: number = 0;
    public count: number = 0;
    public capacity: number = 0;
    public isActivated: boolean = false;
    public refundRules: RefundRuleDto[] = [];
    public thumbnailFileName: string = "";
}

export class RefundRuleDto {
    public leftDays: number = 0;
    public rate: number = 0;

    constructor(leftDays: number, rate: number) {
        this.leftDays = leftDays;
        this.rate = rate;
    }
}

export class ListenerDto {
    public seq: number = 0;
    public applicationDate!: string;
    public isMembers: boolean = false;
    public headCount: number = 0;
    public name: string = "";
    public email: string = "";
    public phone: string = "";
    public payment: number = 0;
    public depositor: string = "";
    public status: number = 0;
}